/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_Wry_Moth_RushInputs */

const en_free_wry_moth_rush = /** @type {(inputs: Free_Wry_Moth_RushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal Information`)
};

const de_free_wry_moth_rush = /** @type {(inputs: Free_Wry_Moth_RushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persönliche Informationen`)
};

/**
* | output |
* | --- |
* | "Personal Information" |
*
* @param {Free_Wry_Moth_RushInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const free_wry_moth_rush = /** @type {((inputs?: Free_Wry_Moth_RushInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Wry_Moth_RushInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_free_wry_moth_rush(inputs)
	return de_free_wry_moth_rush(inputs)
});